import React, { Component } from "react";
import { connect } from "react-redux";
import ReactTooltip from "react-tooltip";
import { checkOutPayment, closeCart } from "../../../common/actions";
import { numberWithCommas } from "../../../utility/commonHelpers";
import { Link } from "react-router-dom";
const mapStateToProps = (state) => ({
  subscribePlanInfo: state.subscribePlanInfo,
});
class PricingContainerRight extends Component {
  constructor(props) {
    super(props);
    this.checkoutPayment = this.checkoutPayment.bind(this);
    this.closeCart = this.closeCart.bind(this);
    this.calculateGrandTotal = this.calculateGrandTotal.bind(this);
  }
  checkoutPayment() {
    this.props.dispatch(checkOutPayment({ invoiceInfo: this.props.subscribePlanInfo.optedPlanDetails }));
  }
  closeCart() {
    this.props.dispatch(closeCart());
  }
  calculateGrandTotal(totalAmount, adjustment) {
    return parseInt(totalAmount - adjustment);
  }
  render() {
    const planDetails = this.props.subscribePlanInfo.optedPlanDetails;
    return (
      <div className="col-md-4 col-sm-12 col-xs-12" id="pages">
        <div className="x_panel paymentDesc">
          <div className="x_content">
            <div
              className={"paymentDesc page " + this.props.subscribePlanInfo.showDetails}
              id="information"
              data-page="information"
            >
              <div className="x_content">
                <div className="pricing_features">
                  <h3>No monthly payment and your credits never expire</h3>
                  <br />
                  <ul className="list-unstyled text-left">
                    <li>
                      <i className="fa fa-check text-primary" /> <strong>Volume Discount :</strong> The more you verify,
                      the lower the cost.
                      <br />
                    </li>
                    <li>
                      <i className="fa fa-check text-primary" /> <strong>Free Deduplication :</strong> We remove
                      duplicate and invalid format emails at no extra cost.
                      <br />
                    </li>
                    <li>
                      <i className="fa fa-check text-primary" /> <strong>No Hidden Fees :</strong> No charges for
                      unknown or duplicate emails.
                    </li>
                  </ul>
                </div>
                <div className="pricing_footer">
                  <p>Need some assistance?</p>
                  <Link to="/help">
                    <span className="btn btn-default bg-orange" role="button">
                      Help{" "}
                    </span>
                  </Link>
                </div>
              </div>
            </div>

            <div
              className={"checkout page " + this.props.subscribePlanInfo.showCart}
              id="portfolio"
              data-page="portfolio"
            >
              <h3>
                Summary
                <a href="#" className="close-sign">
                  <i className="fa fa-times" aria-hidden="true" onClick={this.closeCart} />
                </a>
              </h3>
              <section id="checkout-cart">
                <table width="100%" border="1">
                  <tbody>
                    <tr>
                      <th scope="col" width="25%">
                        Package
                      </th>
                      <th scope="col" width="45%">
                        Price
                      </th>
                    </tr>
                    <tr>
                      <th scope="row">{planDetails.planGroup}</th>
                      <td>
                        {" "}
                        $
                        {planDetails.perMonthPrice == 0
                          ? numberWithCommas(planDetails.discountedprice)
                          : numberWithCommas(planDetails.perMonthPrice) + "/mo x  " + planDetails.Freequency}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Total</strong>
                      </td>
                      <td>
                        <strong>${numberWithCommas(planDetails.discountedprice)}</strong>
                      </td>
                    </tr>

                    <tr className={planDetails.adjustment > 0 ? "block" : "hide"}>
                      <td>
                        <strong>Adjustment</strong>
                      </td>
                      <td>
                        <strong>${numberWithCommas(planDetails.adjustment)}</strong>
                        <p
                          className="adjustment-info"
                          data-tip="Discount from unused credits"
                          //{
                          // "Previous Plan Amount : $" +
                          // planDetails.previousPlanAmount +
                          // " Previous plan days : " +
                          // planDetails.previousPlanFrequency +
                          // " Charge Per Day : $" +
                          // planDetails.chargePerDay +
                          // " Previous Plan Unused Days : " +
                          // planDetails.previousPlanUnusedDays
                          //}
                        >
                          <i className="fa fa-question-circle" aria-hidden="true" />
                        </p>
                        <ReactTooltip />
                      </td>
                    </tr>
                    <tr className={planDetails.adjustment > 0 ? "block" : "hide"}>
                      <td>
                        <strong>Grand Total</strong>
                      </td>
                      <td>
                        <strong>
                          $
                          {numberWithCommas(
                            this.calculateGrandTotal(planDetails.discountedprice, planDetails.adjustment)
                          )}
                        </strong>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <br />
                <button
                  disabled={this.props.subscribePlanInfo.disableButton}
                  type="button"
                  onClick={this.checkoutPayment}
                  className="btn btn-primary btn-block bg-green checkoutBtn btn-lg"
                  data-page="blog"
                >
                  Checkout Now
                </button>
              </section>
              <br />
              <br />
              <p className="price-cycle">
                {planDetails.planType == "daily"
                  ? "*Note:The next charge on your " +
                    planDetails.planGroup +
                    " billing cycle will be for $" +
                    numberWithCommas(planDetails.discountedprice) +
                    " on " +
                    planDetails.planexpireson
                  : ""}
              </p>
            </div>

            <div className="page hide" data-page="blog" id="blog">
              <form id="demo-form" data-parsley-validate="" noValidate="">
                <h3>Account Info</h3>
                <p>
                  <label htmlFor="fullname">Card Number * :</label>
                  <input id="fullname" className="form-control" name="fullname" required="" type="text" />
                </p>
                <p>
                  <label htmlFor="fullname">Expiration * :</label>
                  <input id="fullname" className="form-control" name="fullname" required="" type="text" />
                </p>
                <p>
                  <label htmlFor="fullname">CVC * :</label>
                  <input id="fullname" className="form-control" name="fullname" required="" type="text" />
                </p>
                <hr />
                <p>
                  <label htmlFor="fullname">Coupon * :</label>
                  <input id="fullname" className="form-control" name="fullname" required="" type="text" />
                </p>

                <p>
                  <label htmlFor="fullname">Full Name * :</label>
                  <input
                    autoComplete="cc-number"
                    autoCorrect="off"
                    name="cardnumber"
                    aria-label="Credit or debit card number"
                    placeholder="Card number"
                    aria-placeholder="Card number"
                    aria-invalid="false"
                    value=""
                    className="form-control"
                    type="tel"
                  />
                </p>

                <p>
                  <label htmlFor="email">Email * :</label>
                  <input
                    id="email"
                    className="form-control"
                    name="email"
                    data-parsley-trigger="change"
                    required=""
                    type="email"
                  />
                </p>

                <p>
                  <label htmlFor="email">Full Address :</label>
                  <textarea
                    id="message"
                    required="required"
                    className="form-control"
                    name="message"
                    data-parsley-trigger="keyup"
                    data-parsley-minlength="20"
                    data-parsley-maxlength="100"
                    data-parsley-minlength-message="Come on! You need to enter at least a 20 caracters long comment.."
                    data-parsley-validation-threshold="10"
                  />
                </p>

                <p>
                  <label htmlFor="email">City :</label>
                  <input
                    id="email"
                    className="form-control"
                    name="email"
                    data-parsley-trigger="change"
                    required=""
                    type="email"
                  />
                </p>

                <p>
                  <label htmlFor="email">Country :</label>
                  <input
                    id="email"
                    className="form-control"
                    name="email"
                    data-parsley-trigger="change"
                    required=""
                    type="email"
                  />
                </p>

                <div className="autoRecharge">
                  <input type="checkbox" /> <label>Auto-Recharge</label>
                </div>

                <br />
                <a href="#" className="btn btn-primary btn-block bg-green">
                  Purchage Pacakge
                </a>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default connect(mapStateToProps)(PricingContainerRight);



// WEBPACK FOOTER //
// ./src/components/Pricing/PricingContainer/PricingContainerRight.js